// extracted by mini-css-extract-plugin
export default {"container":"NoPage_container__jKHq6","container_center":"NoPage_container_center__5j3w2"};